import styled from 'styled-components';
import { Select as SelectAntd } from 'antd';
import color from '../../configs/color';

const Select = styled(SelectAntd)`
  color: ${color.black2};
  font-size: 16px;
  .ant-select-selector {
    border-color: ${color.grey1} !important;
    border-radius: 12px !important;
    min-height: 44px;
    .ant-select-selection-item {
      line-height: 44px;
      font-size: 16px;
    }
  }

  .ant-select-selection-overflow-item {
    .ant-select-selection-item {
      line-height: unset;
      align-items: center;
    }
  }

  &.hide-tag {
    .ant-select-selection-overflow-item-rest {
      margin-left: 8px;
      .ant-select-selection-item {
        display: none;
        .ant-select-selection-item-content {
          margin-right: 0;
        }
      }
    }
  }

  &.auto-height {
    .ant-select-selector {
      height: auto !important;
      padding: 8px 12px;
      .ant-select-selection-item {
        line-height: normal;
        height: auto !important;
        :after {
          display: none;
        }
      }
    }
  }
  &.select-with-avatar {
    .ant-select-selector {
      .ant-select-selection-item {
        .component_accountCard {
          .ant-avatar {
            transform: scale(0.8);
          }
          .component_account_card_description {
            display: none;
          }
        }
      }
    }
  }
`;

export default Select;

export const SelectUserCampaign = styled(SelectAntd)`
  color: ${color.black2};
  font-size: 16px;
  .ant-select-selector {
    border-color: ${color.grey1} !important;
    border-radius: 12px !important;
    min-height: 50px;
    .ant-select-selection-item {
      line-height: 44px;
      font-size: 16px;
      display: flex;
    }
  }
`;
